module.exports = __webpack_public_path__ + "img/Nginx.a39d791.svg";